.root {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0 !important; /* cancel an annoying default in customers-react.scss*/
  cursor: pointer;

  &:focus-within {
    color: var(--primary);
    text-decoration: underline;
  }
}

.disabled {
  cursor: not-allowed;
}

.input {
  position: absolute;
  opacity: 0;
}

.check {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%;
  height: 80%;
  opacity: 0;
  transform: translateX(-50%) translateY(-50%);
}

.block {
  justify-content: space-between;
  width: 100%;
}

.reverse {
  flex-direction: row-reverse;
}

.label {
  flex-grow: 0;
  padding-top: 2px;
  color: var(--on-background);

  :checked + & {
    font-weight: var(--font-weight-regular);
  }

  :disabled + & {
    color: var(--gray-500);
  }
}

.noWrapLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.faux {
  position: relative;
  display: block;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  color: white;
  background-color: transparent;
  border: 1px solid var(--gray-400);
  border-radius: 4px;

  [aria-checked="true"] &,
  :checked ~ & {
    background-color: var(--on-background);
    border-color: var(--on-background);

    .check {
      color: var(--background);
      opacity: 1;
    }
  }

  [aria-disabled="true"] &,
  :disabled ~ & {
    border-color: var(--gray-500);
    filter: grayscale(1);
  }
}
